import { Col, SkeletonDots, YesObject } from '@yes.technology/react-toolkit'

import { Row } from '@yes.technology/react-toolkit'

import { StyledGrid } from 'shared/style/grid'

import EmptyStates from 'component/EmptyStates/EmptyStates'
import Event from './Event'
import { CardsGrid } from './EventCardContainer.styles'

type EventsGridProps = {
  isLoading: boolean
  events: YesObject[]
  cardVariant?: React.ComponentProps<typeof Event>['variant']
}

const EventsGrid = ({
  events = [],
  cardVariant,
  isLoading
}: EventsGridProps) => {
  if (!isLoading && events.length === 0) {
    return (
      <StyledGrid>
        <Row style={{ justifyContent: 'center' }}>
          <Col lg={12}>
            <EmptyStates state='no-results-found' />
          </Col>
        </Row>
      </StyledGrid>
    )
  }

  return (
    <StyledGrid>
      <CardsGrid>
        {isLoading ? (
          <Col lg={12}>
            <SkeletonDots />
          </Col>
        ) : (
          events.map((object) => {
            return (
              <Event key={object.uuid} {...{ object }} variant={cardVariant} />
            )
          })
        )}
      </CardsGrid>
    </StyledGrid>
  )
}

export default EventsGrid
